// removed by extract-text-webpack-plugin
module.exports = {"root":"IconReviewStar__root__CHYQZ","filled":"IconReviewStar__filled__2ykNO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconReviewStar/IconReviewStar.css
// module id = 1847
// module chunks = 0